var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.injectUserId() == _vm.row.id)?_c('img',{staticClass:"radio-img",attrs:{"src":require("@/assets/public/active-radio.png"),"alt":""}}):_c('img',{staticClass:"radio-img",attrs:{"src":require("@/assets/public/default-radio.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }